import { createApp } from 'vue'
import App from './App.vue'
import router from './router.js'
import axios from 'axios'
import './registerServiceWorker'
// 👇 1. ایمپورت پکیج
import { useFavicon } from '@vueuse/core'

const app = createApp(App)
const url = process.env.VUE_APP_API_URL

app.use(router)
app.mount('#app')

// 👇 2. تعریف متغیر فاوآیکون
const icon = useFavicon()

axios.get(`${url}/admin/setting`).then(res => {
  const data = res.data.data || res.data;
  if (!data) return;

  if (data.title) document.title = data.title;

  if (data.favicon) {
    let finalFaviconUrl = data.favicon;

    // اصلاح آدرس اگر http نداشت
    if (!finalFaviconUrl.startsWith('http')) {
       const baseUrl = url.endsWith('/') ? url.slice(0, -1) : url;
       const imagePath = finalFaviconUrl.startsWith('/') ? finalFaviconUrl.slice(1) : finalFaviconUrl;
       finalFaviconUrl = `${baseUrl}/${imagePath}`;
    }

    // اضافه کردن ورژن برای دور زدن کش
    const noCacheUrl = `${finalFaviconUrl}?v=${Date.now()}`;

    // 👇 3. تغییر فاوآیکون با یک خط کد!
    icon.value = noCacheUrl; 
    
    console.log("✅ Favicon updated via VueUse:", noCacheUrl);
  }

}).catch(err => {
  console.error("Setting Error:", err);
});